/*
 * @Author: Cozy
 * @Date: 2024-05-08 11:39:59
 * @LastEditors: Cozy
 * @LastEditTime: 2024-06-27 17:24:09
 * @FilePath: /SChatUI/src/index.js
 * @Description: 
 * 
 * Copyright (c) 2024 by Cozy, All Rights Reserved. 
 */
import React from "react";
import ReactDOM from "react-dom/client"; // Import the new method for creating the root
import App from "./App";
import "./styles.css";

// Get the root element
const rootElement = document.getElementById("root");

// Use `createRoot` to create the root object for rendering
const root = ReactDOM.createRoot(rootElement);
// 用于调试环境变量的读取
console.log('NODE_ENV:', process.env.NODE_ENV); 

if (process.env.NODE_ENV === 'production') {
  // Save the original console methods
  const originalConsole = {
    log: console.log,
    debug: console.debug,
    info: console.info,
    warn: console.warn,
    error: console.error
  };

  // Override console methods to only output warn and error in production
  console.log = function () { };
  console.debug = function () { };
  console.info = function () { };
  // Keep console.warn and console.error as is
  console.warn = originalConsole.warn;
  console.error = originalConsole.error;
}


// Render the app using React's strict mode
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
